import React, { memo, useEffect, useCallback, useState, useRef } from 'react';
import { Modal } from 'antd';
import { Link } from 'react-router-dom';
import bytes from 'bytes';
import classNames from 'classnames';

import { createSelector } from 'reselect';
import { useSelector, useDispatch } from 'react-redux';
import { CONTEXT } from '../../config';
import { imgLocalUrl, logNative } from '../../utils/utils';
import { PCStoreJsBridge } from '../../nativeapi';
import styles from './ResidualSoft.module.less';
import defaultImg from '../../static/default.svg';
import Loading from '../../components/Loading/Loading';
import { logging } from '../../actions/log';
import {
  modifyResidualData,
  removeResidual,
  removeTempResidual,
  stopDeleteResidual,
} from '../../actions/uninstall';
import residual_blank from '../../static/residual_blank.png';
import Dialog from '../../components/Dialog/Dialog';
import fingerHeart from '../../static/finger_heart.gif';
import loading from '../../static/loading.gif';

const modalStyle = {
  position: 'fixed',
  top: `calc(50% - 310px)`,
  left: '225px',
  zIndex: 1000,
  height: '440px',
  background: '#fff',
  boxShadow: '0px 3px 10px 0px rgba(0, 0, 0, 0.3)',
  borderRadius: '4px',
  boxSizing: 'border-box',
};

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectClearStatus = createSelector(
  state => state.uninstall,
  uninstall => uninstall.clearStatus,
);

const Desc = memo(({ count = {}, status }) => {
  const clearStatus = useSelector(selectClearStatus);
  if (status === clearStatus.SCANING) {
    return (
      <div className={styles.residual_desc_text}>
        {/* <i className={styles.loading} /> */}
        <img src={loading} className={styles.loading} />
        <span className={styles.residual_desc_count}>扫描中...</span>
      </div>
    );
  }
  if (status === clearStatus.LOADING) {
    return (
      <div className={styles.residual_desc_text}>
        {/* <i className={styles.loading} /> */}
        <div className={styles.loading}>
          <img src={loading} />
        </div>

        <div className={styles.residual_desc_count}>正在清理卸载残留，请耐心等待...</div>
      </div>
    );
  }
  if (status === clearStatus.CLEAR_SUCC) {
    return (
      <div className={styles.residual_desc_text}>
        {/* <i
          className={classNames('iconfont icon-residual_succ', styles.icon_tips, styles.icon_succ)}
        /> */}
        <div className={styles.finish}>
          <img src={fingerHeart} />
        </div>

        <div className={styles.residual_desc_count} style={{ maxWidth: '400px' }}>
          <span className={styles.text_bold}> {count.totalNum || 0}</span> 项残留已清理完成
          {count.totalSize && (
            <>
              ，已为你节省<span className={styles.text_bold}> {count.totalSize}</span> 空间
            </>
          )}
        </div>
      </div>
    );
  }
  if (status === clearStatus.CLEAR_ERR) {
    return (
      <div className={styles.residual_desc_text}>
        <i className={classNames('iconfont icon-tips', styles.icon_tips)} />
        <div className={styles.residual_desc_count}>清理遇到异常，请稍后再试。</div>
      </div>
    );
  }
  return (
    <div className={styles.residual_desc_text}>
      <i className={classNames('iconfont icon-tips', styles.icon_tips)} />
      <div className={classNames(styles.residual_desc_count, styles.text_color)}>
        有<span className={styles.text_bold}>{count.totalNum || 0}</span>项
        {count.totalSize && (
          <>
            , 共<span className={styles.text_bold}>{count.totalSize}</span>
          </>
        )}
        卸载残留
      </div>
    </div>
  );
});

export default memo(({ residualInfo, soft }) => {
  const dispatch = useDispatch();
  const [filesysList, setFilesysList] = useState([]);
  const [regsysList, setRegsysList] = useState([]);
  const [count, setCount] = useState({});
  const [visible, setVisible] = useState(false);
  const logInfoData = useSelector(selectLogInfo);
  const scanResidualSoftTimer = useRef(); // 扫描超长定时器
  const deleteResidualSoftTimer = useRef(); // 删除残留文件超长异常
  const latestResidualInfo = useRef(); // 维护一个残留值供定时器必报使用
  const clearStatus = useSelector(selectClearStatus);

  // 后期修补 卸载根目录的bug
  // const [isCantUninstall, setIsCantUninstall] = useState(true);

  // 控制模态窗的显示状态
  const handleModalVisible = useCallback(
    type => () => {
      setVisible(type);
      // 打开卸载页面查看残留弹窗，订阅历史卸载软件残留信息
      if (type) {
        const { source, softGUID } = residualInfo;
        try {
          // 来自之前的卸载残留订阅扫描消息
          if (source === 'residualList' && latestResidualInfo.current.percent < 100) {
            PCStoreJsBridge.getSoftwareResidual({ softGUID });
            // 扫描超过30s 需要关闭此次扫描
            scanResidualSoftTimer.current = setTimeout(() => {
              if (latestResidualInfo.current.percent < 100) {
                PCStoreJsBridge.stopScanSoftwareResidual({ softGUID: residualInfo.softGUID });
                dispatch(removeResidual({ softGUID: residualInfo.softGUID }));
                dispatch(removeTempResidual({ softGUID: residualInfo.softGUID }));
                handleModalVisible(false)();
                // dispatch(
                //   logging({
                //     category: 'C',
                //     action: 'Uninstall_Timeout',
                //     label: '',
                //     param2: {
                //       source: 'Mysofts',
                //       source_p: logInfoData.source_p,
                //       source_pp: logInfoData.source_pp,
                //       softid: residualInfo.SoftID,
                //       softname: residualInfo.displayName,
                //     },
                //   }),
                // );
              }
            }, 30000);
          }
        } catch (err) {
          logNative(`卸载残留 页面卸载软件获取文件夹与注册表残留失败`, residualInfo, true, true);
        }
      }
      // 打开弹窗打桩
      if (type) {
        dispatch(
          logging({
            category: 'C',
            action: 'View_Residuals',
            label: '',
            param2: {
              source: 'Mysofts',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              softid: residualInfo.SoftID,
              softname: residualInfo.displayName,
            },
          }),
        );
      }
    },
    [visible],
  );

  useEffect(() => {
    latestResidualInfo.current = {
      ...residualInfo,
    };
    const status = [clearStatus.CLEAR_ERR, clearStatus.CLEAR_SUCC];
    if (status.indexOf(residualInfo.status) > -1) {
      handleModalVisible(false)();
    }
  });

  useEffect(() => {
    return () => {
      clearTimeout(scanResidualSoftTimer.current);
      clearTimeout(deleteResidualSoftTimer.current);
    };
  }, []); // 定时器删除

  // 关闭模态窗 --发现此软件已经没有残留，删除该软件
  useEffect(() => {
    if (!visible && !residualInfo.hasResidual) {
      PCStoreJsBridge.stopScanSoftwareResidual({ softGUID: residualInfo.softGUID });
      PCStoreJsBridge.removeSoftwareResidual({ softGUID: residualInfo.softGUID });
      dispatch(removeResidual({ softGUID: residualInfo.softGUID }));
      dispatch(removeTempResidual({ softGUID: residualInfo.softGUID }));
    }
  }, [visible, residualInfo]);

  // 统计来自页面卸载的残留信息
  useEffect(() => {
    const file = [];
    const regsy = [];
    const { totalNum, totalSize } = residualInfo;
    setCount({
      totalNum,
      totalSize: +totalSize > 0 ? bytes(+totalSize || 0, { decimalPlaces: 2 }) : '',
    });
    // 在页面内卸载的软件可以获取它的残留列表 不需要扫描{
    const { residualResult } = residualInfo;
    if (residualResult) {
      const { residualList: residualLists } = residualResult;
      residualLists &&
        residualLists.forEach(item => {
          if (item.sysType === 'filesys') {
            file.push(item);
          } // 文件系统
          if (item.sysType === 'regsys') {
            regsy.push(item);
          } // 注册表
        });
      setFilesysList(file);
      setRegsysList(regsy);
    }
  }, [residualInfo]);

  // 清理残留软件的信息
  const handleDelete = useCallback(() => {
    dispatch(
      modifyResidualData({
        softGUID: residualInfo.softGUID,
        status: clearStatus.LOADING,
      }),
    );
    const { displayName, softGUID } = residualInfo;
    PCStoreJsBridge.deleteSoftwareResidual({
      deleAll: true,
      displayName,
      softGUID,
    });
    // 30s 后停止清理
    deleteResidualSoftTimer.current = setTimeout(() => {
      // 设置定时器如果30s 仍然还在残留清理，则停止残留清理，状态修改为异常
      if (latestResidualInfo.current.status === clearStatus.LOADING) {
        handleModalVisible(false)();
        dispatch(stopDeleteResidual(residualInfo));
      }
    }, 30000);
    // 删除文件打桩
    dispatch(
      logging({
        category: 'C',
        action: 'Force_Uninstall',
        label: '',
        param2: {
          source: 'Mysofts',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: residualInfo.SoftID,
          softname: residualInfo.displayName,
        },
      }),
    );
  }, [residualInfo]);

  // 打开指定位置文件夹
  const handleOpenFileByPath = ppath => () => {
    let path = ppath;
    try {
      const pathList = ppath && ppath.split('\\');
      if (pathList.length > 1 && pathList.slice(-1)[0].indexOf('.') > -1) {
        path = pathList.slice(0, -1).join('\\');
      }
    } catch (err) {
      logNative(` 残留文件 打开文件夹失败 ${path}`, path);
    }
    PCStoreJsBridge.openFolder(path);
    // 打桩
    dispatch(
      logging({
        category: 'C',
        action: 'View_Window',
        label: '',
        param2: {
          source: 'Mysofts',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: residualInfo.SoftID,
          softname: residualInfo.displayName,
        },
      }),
    );
  };
  // /**
  //  * 添加临时逻辑判断, 后期修补 卸载根目录的bug
  //  */
  // const judgeChildPath = pathStr => {
  //   if (pathStr) {
  //     let pathList = pathStr.split(/\\/);
  //     let startIndex = pathList.findIndex(item => item === '..');
  //     while (startIndex > -1) {
  //       pathList.splice(startIndex - 1, 2);
  //       startIndex = pathList.findIndex(item => item === '..');
  //     }
  //     pathList = pathList.filter(item => item && !/\.exe$/.test(item));
  //     return pathList.length > 1;
  //   }
  //   return false;
  // };

  // // 后期修补 卸载根目录的bug
  // useEffect(() => {
  //   if (
  //     !judgeChildPath(soft.installString, soft) &&
  //     !judgeChildPath(soft.MainExePath, soft) &&
  //     !judgeChildPath(soft.installPath, soft)
  //   ) {
  //     setIsCantUninstall(false);
  //     logNative(`卸载目录不常规，屏蔽这个软件 ${soft}`, {}, true, true);
  //   }
  // }, [soft]);
  // // 后期修补 卸载根目录的bug
  // if (!isCantUninstall) {
  //   return null;
  // }

  return (
    <div className={styles.residual_soft}>
      <div className="soft_logo">
        <img
          src={
            // eslint-disable-next-line no-nested-ternary
            soft.logoFile || imgLocalUrl(soft.displayIcon) || defaultImg
          }
          alt=""
        />
      </div>
      <div className="soft_info">
        {soft.SoftID ? (
          <Link
            className="soft_info_name"
            to={`${CONTEXT}/detail/soft/${soft.SoftID}/${soft.bizInfo || '{}'}`}
          >
            <div className="soft_info_name" title={soft.displayName}>
              {soft.displayName}
            </div>
          </Link>
        ) : (
          <div className="soft_info_name_" title={soft.displayName}>
            {soft.displayName}
          </div>
        )}
        <div className="soft_info_desc" title={soft.publisher}>
          {soft.publisher}
        </div>
      </div>
      <div
        className={styles.soft_residual}
        style={{ width: residualInfo && residualInfo.status === 'init' ? '324px' : '394px' }}
      >
        <div
          className={classNames({
            [styles.soft_residual_text]: residualInfo && residualInfo.status === clearStatus.init,
          })}
        >
          <Desc count={count} status={residualInfo && residualInfo.status} soft={residualInfo} />
        </div>
        {residualInfo && residualInfo.status === clearStatus.init && (
          <div className={classNames(styles.soft_residual_btn)} onClick={handleModalVisible(true)}>
            查看
          </div>
        )}
      </div>
      {residualInfo && residualInfo.status === clearStatus.init && (
        <div className={classNames(styles.clear_operation)}>
          <div className={classNames('uninstall_btn', styles.clear_btn)} onClick={handleDelete}>
            <div> 强力清理</div>
          </div>
        </div>
      )}
      {visible && (
        <Dialog
          title=""
          maskStyle={styles.mask}
          containerStyle={styles.containerStyle}
          handleClose={handleModalVisible(false)}
        >
          <div className={styles.modal_container}>
            <div className={styles.modal_header}>
              <div className={styles.title}>
                <img
                  src={
                    // eslint-disable-next-line no-nested-ternary
                    soft.logoFile || imgLocalUrl(soft.displayIcon) || defaultImg
                  }
                  alt=""
                  className={styles.title_img}
                />
                <div className={styles.title_softname}>{soft.displayName}</div>
                {residualInfo.hasResidual && (
                  <div className={styles.title_residual_desc}>
                    <span>
                      有<span className={styles.text_bold}> {count.totalNum || 0} </span>项
                      {count.totalSize && (
                        <>
                          , 共<span className={styles.text_bold}> {count.totalSize} </span>
                        </>
                      )}
                      卸载残留
                    </span>
                  </div>
                )}
              </div>
              <div className={styles.divider} />
            </div>
            {residualInfo.hasResidual && (
              <>
                <div className={styles.modal_content}>
                  {regsysList.length > 0 && (
                    <div className={styles.residual}>
                      <div className={styles.residual_title}>注册表残留{regsysList.length}项</div>
                      {regsysList.map((info, index) => {
                        return (
                          <div className={styles.residual_item} key={index}>
                            <div className={styles.residual_item_path}>{info.fileName}</div>
                            <div
                              className={styles.residual_item_icon}
                              onClick={handleOpenFileByPath(info.fileName)}
                            >
                              <i
                                className={classNames('iconfont icon-residual_file')}
                                styles={{ fontSize: '12px' }}
                              />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                  {filesysList.length > 0 && (
                    <div className={styles.residual}>
                      <div className={styles.residual_title}>文件夹残留{filesysList.length}项</div>
                      {filesysList.map((info, index) => {
                        return (
                          <div className={styles.residual_item} key={index}>
                            <div className={styles.residual_item_path}>{info.fileName}</div>
                            <div
                              className={styles.residual_item_icon}
                              onClick={handleOpenFileByPath(info.fileName)}
                            >
                              <i
                                className={classNames('iconfont icon-residual_file')}
                                styles={{ fontSize: '12px' }}
                              />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
                {residualInfo.percent >= 100 && (
                  <div className={styles.modal_button}>
                    <div
                      className={classNames(styles.now_clear_btn, {
                        [styles.disabled]:
                          residualInfo.status === clearStatus.LOADING ||
                          residualInfo.status === clearStatus.CLEAR_ERR ||
                          residualInfo.status === clearStatus.CLEAR_SUCC,
                      })}
                      onClick={() => {
                        if (residualInfo.status !== clearStatus.LOADING) {
                          handleDelete();
                        }
                      }}
                    >
                      {residualInfo.status === clearStatus.LOADING ||
                      residualInfo.status === clearStatus.CLEAR_ERR ||
                      residualInfo.status === clearStatus.CLEAR_SUCC
                        ? '清理中'
                        : '强力清理'}
                    </div>
                  </div>
                )}
              </>
            )}
            {!residualInfo.hasResidual && (
              <div className={styles.residual_blank}>
                <img className={styles.residual_blank_img} src={fingerHeart} alt="" />
                <div className={styles.residual_blank_desc}>残留已被清理，去管理其他软件</div>
                <div className={styles.residual_blank_btn} onClick={handleModalVisible(false)}>
                  好的
                </div>
              </div>
            )}
            {residualInfo.percent < 100 && (
              <div
                style={{
                  height: '200px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Loading />
              </div>
            )}
          </div>
        </Dialog>
      )}
    </div>
  );
});
